<template>
    <div class="contact-detail-item" ref="componentRef">
        <div class="contact-detail-item-details">
            <template v-if="field === 'vipCustomer'">
                <div class="contact-detail-item-input vip-customer">
                    <div class="contact-detail-item-input-label">
                        <div
                            :class="{ 'material-icons': true, vip: contact.vipCustomer }"
                            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                            :content="`${$t('message.vipCustomer')} `"
                        >
                            star
                        </div>
                        {{ label }}
                    </div>
                    <div class="contact-detail-item-input-val">
                        <a-switch
                            :checked="value"
                            @change="saveVipCustomer"
                            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                            :content="getSwitchTippyValue()"
                        />
                    </div>
                </div>
            </template>
            <template v-else-if="field === 'owner'">
                <div
                    class="contact-detail-item-input owner"
                    @click="
                        () => {
                            editModal = true;
                        }
                    "
                >
                    <div
                        class="contact-detail-item-icon"
                        v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                        :content="getOwnerTippyValue()"
                    >
                        <div class="material-icons">person_pin</div>
                    </div>
                    <div class="contact-detail-item-input owner-field">
                        <div
                            class="contact-detail-item-input-label"
                            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                            :content="getOwnerTippyValue()"
                        >
                            {{ label }}
                        </div>
                        <div class="contact-detail-item-input-val d-flex justify-content-between align-items-center">
                            <div class="owner-content">
                                <div
                                    v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                                    :content="getOwnerTippyValue()"
                                >
                                    <template v-if="value">
                                        <div class="owner-info">
                                            <AgentAvatar :userID="value" :size="24" />
                                            <span class="owner-name">{{ getOwnerName(value) }}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ $t("message.unowned") }}
                                    </template>
                                </div>

                                <div
                                    v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                                    :content="$t('chat.contactDetailItem.removeOwnership')"
                                    class="set-unowned"
                                    @click.stop="
                                        (event) => {
                                            event.stopPropagation();
                                            saveOwner('');
                                        }
                                    "
                                    v-if="value"
                                >
                                    <div class="material-icons">close</div>
                                </div>
                                <div
                                    class="set-unowned"
                                    v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                                    :content="$t('chat.contactDetailItem.assignOwnershipToMe')"
                                    @click.stop="
                                        (event) => {
                                            event.stopPropagation();
                                            saveOwner(user._id);
                                        }
                                    "
                                    v-else
                                >
                                    <div class="material-icons">assignment_ind</div>
                                </div>
                            </div>
                            <div class="edit-icon">
                                <a-icon type="edit" />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="contact-detail-item-icon">
                    <slot name="icon" />
                </div>
                <div class="contact-detail-item-input">
                    <div class="contact-detail-item-input-label">{{ label }}</div>
                    <div
                        class="contact-detail-item-input-val"
                        v-if="value != null"
                        v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                        :content="getTippyValue()"
                    >
                        <template v-if="field === 'tags'">
                            <div class="tags-container">
                                <span
                                    v-for="tag in mappedTags"
                                    :key="tag._id"
                                    :style="getTagStyle(tag.color)"
                                    class="tag-label"
                                >
                                    <span class="remove-tag" @click="removeTag(tag._id)">×</span>
                                    {{ tag.name }}
                                </span>
                            </div>
                        </template>
                        <template v-else-if="inputType === 'json'">
                            <button class="classic-button visitor-attr" @click="JSONModal = true">
                                {{ $t("message.jsonPreview") }}
                            </button>
                            <Modal2 v-if="JSONModal" :title="label" @cancel="JSONModal = false" :show-footer="false">
                                <prism-editor
                                    :value="editedValue"
                                    class="my-editor"
                                    :line-numbers="false"
                                    :highlight="highlighter"
                                    readonly
                                />
                                <div style="display: flex; justify-content: space-between">
                                    <SupsisButton @click="copyJsonToken">{{ $t("message.copy") }}</SupsisButton>
                                    <SupsisButton @click="JSONModal = false"> {{ $t("message.cancel") }}</SupsisButton>
                                </div>
                            </Modal2>
                        </template>
                        <template v-else-if="inputType === 'date'">
                            {{ $moment(value).format('DD/MM/YYYY') }}
                        </template>
                        <template v-else-if="inputType === 'url'">
                            <a :href="value" target="_blank" rel="noopener noreferrer" class="url-link">
                                {{ value }}
                            </a>
                        </template>
                        <template v-else>
                            {{ maskContactInfo(field, value, 5) }}
                        </template>
                    </div>
                    <div class="contact-detail-item-input-val add-link" v-else-if="showAdd" @click="showAddModal">
                        + {{ $t("message.add") }}
                    </div>
                </div>
            </template>
        </div>
        <div
            class="contact-detail-item-actions"
            v-if="value != null && inputType !== 'switch' && inputType !== 'select'"
        >
            <template v-if="isCompactView">
                <a-popover
                    overlayClassName="actionSettingsButton"
                    v-model="isPopoverVisible"
                    placement="bottomRight"
                    title=""
                    trigger="click"
                >
                    <template #content>
                        <div class="more-actions">
                            <button
                                v-if="showEdit && !(isShouldMask(value) || isMaskContactInfo(field))"
                                class="action-button edit-btn"
                                @click="handleEdit"
                            >
                                <span class="material-icons">edit</span>
                                <span class="action-text">{{ $t("message.edit") }}</span>
                            </button>
                            <button v-if="showDelete" class="action-button delete-button" @click="showDeleteModal">
                                <span class="material-icons">delete</span>
                                <span class="action-text">{{ $t("chatbotv2.delete") }}</span>
                            </button>
                            <button v-if="showCopy" class="action-button copy-btn" @click="copyValue">
                                <span class="material-icons">content_copy</span>
                                <span class="action-text">{{ $t("message.duplicate") }}</span>
                            </button>
                        </div>
                    </template>
                    <div class="conversation-actions-button more-vert">
                        <div class="material-icons">more_vert</div>
                    </div>
                </a-popover>
            </template>
            <template v-else>
                <div class="action-buttons">
                    <button
                        v-if="showEdit && !(isShouldMask(value) || isMaskContactInfo(field))"
                        class="action-button edit-btn"
                        @click="handleEdit"
                        v-tippy="{ content: $t('message.edit') }"
                    >
                        <span class="material-icons">edit</span>
                    </button>
                    <button
                        v-if="showDelete"
                        class="action-button delete-button"
                        @click="showDeleteModal"
                        v-tippy="{ content: $t('chatbotv2.delete') }"
                    >
                        <span class="material-icons">delete</span>
                    </button>
                    <button
                        v-if="showCopy"
                        class="action-button copy-btn"
                        @click="copyValue"
                        v-tippy="{ content: $t('message.duplicate') }"
                    >
                        <span class="material-icons">content_copy</span>
                    </button>
                </div>
            </template>
            <slot name="actions"></slot>
        </div>

        <Modal2
            v-if="editModal && field === 'owner'"
            :title="$t('message.transferOwnership')"
            @cancel="editModal = false"
            :showFooter="false"
            xlarge
            :key="'owner-modal' + contact._id + editModal"
        >
            <ChatForwardWindow
                :contact="contact"
                @close="
                    () => {
                        editModal = false;
                    }
                "
            />
        </Modal2>
        <Modal2
            v-if="editModal && field === 'vipCustomer'"
            :title="$t('chat.contactDetailItem.vipCustomer')"
            @cancel="editModal = false"
            :showFooter="false"
            :key="'vip-customer-modal' + contact._id"
        >
            <div id="vip-customer-modal-content">
                <div class="description"></div>
                <a-switch v-model="editedValue" />
                <div class="modal-actions">
                    <SupsisButton @click="editModal = false">{{ $t("message.cancel") }}</SupsisButton>
                    <SupsisButton @click="saveEdit" primary>{{ $t("message.update") }}</SupsisButton>
                </div>
            </div>
        </Modal2>
        <span />
        <Modal2
            v-if="editModal && !isSpecialField"
            :title="`${$t('message.edit')}: ${label}`"
            @cancel="editModal = false"
            :showFooter="false"
            :key="'edit-modal' + contact._id"
        >
            <div id="contact-property-modal-content">
                <template v-if="inputType === 'dropdown'">
                    <a-select 
                        :value="value" 
                        @change="editedValue = $event" 
                        style="width: 100%"
                        show-search
                        :filter-option="filterOption"
                        :placeholder="$t('message.search')"
                    >
                        <a-select-option v-for="option in options" :key="option" :value="option">
                            {{ option }}
                        </a-select-option>
                    </a-select>
                </template>
                <template v-else-if="inputType === 'json'">
                    <prism-editor class="json-editor" v-model="editedValue" :highlight="highlighter" />
                </template>
                <template v-else-if="inputType === 'date'">
                    <a-date-picker
                        :value="editedValue ? $moment(editedValue) : null"
                        @change="(date) => { editedValue = date ? date.toISOString() : '' }"
                        style="width: 100%"
                        format="DD/MM/YYYY"
                    />
                </template>
                <template v-else>
                    <input v-model="editedValue" :placeholder="$t('message.enterNewValue')" />
                </template>
                <div class="modal-actions">
                    <SupsisButton @click="editModal = false">{{ $t("message.cancel") }}</SupsisButton>
                    <SupsisButton @click="saveEdit" type="primary">{{ $t("message.update") }}</SupsisButton>
                </div>
            </div>
        </Modal2>
        <span />
        <Modal2
            v-if="editModal && field === 'preferredLang'"
            :title="$t('message.updatePreferredLanguage')"
            @cancel="editModal = false"
            :showFooter="false"
            :key="'preferred-lang-modal' + contact._id"
        >
            <UpdateContactLang :contact="contact" @close="editModal = false" @save="savePreferredLang" />
        </Modal2>
        <span />
        <Modal2
            v-if="editModal && field === 'tags'"
            :title="$t('message.updateTags')"
            @cancel="editModal = false"
            :showFooter="false"
            :key="'tags-modal' + contact._id"
        >
            <TagDialog
                :value="getContactTagIds()"
                :inlineMode="true"
                @input="saveTagsUpdate"
                @close="editModal = false"
            />
        </Modal2>
        <span />
        <Modal2
            v-if="editModal && field === 'email'"
            :title="$t('message.updateEmail')"
            @cancel="editModal = false"
            :showFooter="false"
            :key="'email-modal' + contact._id"
        >
            <div id="contact-property-modal-content">
                <input v-model="editedValue" type="email" :placeholder="$t('message.enterNewEmail')" />
                <div v-if="!editedValue.includes('@')" class="email-suggestions">
                    <span v-for="domain in emailDomains" :key="domain" @click="appendEmailDomain(domain)">
                        {{ editedValue }}{{ domain }}
                    </span>
                </div>
                <div class="modal-actions">
                    <SupsisButton @click="editModal = false">{{ $t("message.cancel") }}</SupsisButton>
                    <SupsisButton @click="saveEdit" type="primary">{{ $t("message.update") }}</SupsisButton>
                </div>
            </div>
        </Modal2>
        <span />
        <Modal2
            v-if="addModal"
            :title="`${$t('message.add')}: ${label}`"
            @cancel="addModal = false"
            :showFooter="false"
            :key="'add-modal' + contact._id"
        >
            <div id="contact-property-modal-content">
                <template v-if="inputType === 'dropdown'">
                    <a-select 
                        v-model="newValue" 
                        style="width: 100%"
                        show-search
                        :filter-option="filterOption"
                        :placeholder="$t('message.search')"
                    >
                        <a-select-option v-for="option in options" :key="option" :value="option">
                            {{ option }}
                        </a-select-option>
                    </a-select>
                </template>
                <template v-else-if="inputType === 'json'">
                    <prism-editor class="json-editor" v-model="newValue" :highlight="highlighter" />
                </template>
                <template v-else-if="inputType === 'date'">
                    <a-date-picker
                        :value="newValue ? $moment(newValue) : null"
                        @change="(date) => { newValue = date ? date.toISOString() : '' }"
                        style="width: 100%"
                        format="DD/MM/YYYY"
                    />
                </template>
                <template v-else>
                    <input v-model="newValue" :placeholder="$t('message.enterNewValue')" />
                </template>
                <div class="modal-actions">
                    <SupsisButton @click="addModal = false">{{ $t("message.cancel") }}</SupsisButton>
                    <SupsisButton @click="saveAdd" type="primary">{{ $t("message.add") }}</SupsisButton>
                </div>
            </div>
        </Modal2>
        <span />
        <Modal2
            v-if="deleteModal"
            :title="$t('message.deleteConfirmation')"
            @cancel="deleteModal = false"
            :showFooter="false"
            :key="'delete-modal' + contact._id"
        >
            <div id="contact-property-modal-content">
                <p>{{ $t("message.confirmDelete") }}</p>
                <div class="modal-actions">
                    <SupsisButton @click="deleteModal = false">{{ $t("message.cancel") }}</SupsisButton>
                    <SupsisButton @click="confirmDelete" type="primary">{{ $t("message.yesDelete") }}</SupsisButton>
                </div>
            </div>
        </Modal2>
        <span />
    </div>
</template>

<script>
import { copyText2Clipboard, isMaskContactInfo, maskContactInfo, SanitizeHtml } from "../../../utils/utils";
import Modal2 from "../../common/Modal2.vue";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import UpdateContactLang from "./UpdateContactLang.vue";
import TagDialog from "../../TagDialog.vue";
import { mapState } from "vuex";
import _ from "lodash";
import { PrismEditor } from "vue-prism-editor";
import AgentAvatar from "../../common/AgentAvatar.vue";
import ChatForwardWindow from "../../../views/Pages/Chat/components/ChatForwardWindow.vue";

export default {
    name: "ContactDetailItem",
    components: {
        PrismEditor,
        Modal2,
        SupsisButton,
        UpdateContactLang,
        TagDialog,
        AgentAvatar,
        ChatForwardWindow,
    },
    props: {
        contact: {
            type: Object,
            required: true,
        },
        options: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number, Array, Boolean],
            default: null,
        },
        field: {
            type: String,
            default: null,
        },
        showEdit: {
            type: Boolean,
            default: true,
        },
        showDelete: {
            type: Boolean,
            default: true,
        },
        showCopy: {
            type: Boolean,
            default: true,
        },
        showAdd: {
            type: Boolean,
            default: true,
        },
        inputType: {
            type: String,
            default: "text",
        },
        orderable: {
            type: Boolean,
            default: true,
        },
        draggable: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            editModal: false,
            addModal: false,
            deleteModal: false,
            editedValue: "",
            newValue: "",
            emailDomains: ["@gmail.com", "@yahoo.com", "@outlook.com", "@hotmail.com"],
            JSONModal: false,
            isPopoverVisible: false,
            componentWidth: 0,
            isCompactView: false,
            resizeObserver: null,
        };
    },
    mounted() {
        this.editedValue = this.value;
        this.initResizeObserver();
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    computed: {
        ...mapState({
            allTags: (state) => state.tag.tags.data,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            maskSensitiveInfo: (state) => state.setting.settings.maskSensitiveInfo,
            isRoot: (state) => _.get(state, "auth.user.role.isRoot", false),
            user: (state) => state.auth.user,
        }),
        isSpecialField() {
            return ["preferredLang", "tags", "email", "vipCustomer", "owner"].includes(this.field);
        },
        mappedTags() {
            if (this.field !== "tags" || !this.value) return [];
            return this.value.map((tagId) => this.allTags.find((tag) => tag._id === tagId)).filter((tag) => tag);
        },
    },
    methods: {
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        copyJsonToken() {
            copyText2Clipboard(this.editedValue);
            this.$message.success(this.$t('chat.contactDetailItem.contentCopiedSuccess'));
        },
        isOwnerChangeAllowed() {
            return this.isRoot || this.user._id === this.contact.owner || !!this.contact.owner;
        },
        highlighter(code) {
            return Prism.highlight(code, Prism.languages.javascript, "javascript");
        },
        getOwnerVal() {
            return this.contact.owner || "";
        },
        isMaskContactInfo,
        isShouldMask() {
            return (
                !this.isRoot &&
                this.maskSensitiveInfo &&
                (!this.field
                    ? this.value === this.contact.email ||
                      this.value === this.contact.whatsappNumber ||
                      this.value === this.contact.phone
                    : this.contact[this.field] === this.contact.email ||
                      this.contact[this.field] === this.contact.whatsappNumber ||
                      this.contact[this.field] === this.contact.phone)
            );
        },
        maskContactInfo(key, val, length = 4) {
            return this.isMaskContactInfo(key)
                ? maskContactInfo(val, length)
                : this.isShouldMask(val)
                ? maskContactInfo(val, length)
                : val;
        },
        isValue() {
            return this.$slots.value;
        },
        saveVipCustomer(val) {
            this.editedValue = val;
            this.$emit("edit", val);
            this.editModal = false;
        },
        saveOwner(val) {
            const isOwnerExists = !!this.getOwnerVal(this.value);
            const isAllowed = this.isOwnerChangeAllowed();
            if (!isAllowed) {
                this.$message.error(this.$t("message.permissionError"));
                return;
            }
            val = val === "" ? null : val;
            this.editedValue = val;
            this.$emit("edit", val);
            this.editModal = false;
        },
        getSwitchTippyValue() {
            return this.field === "vipCustomer"
                ? this.$t("message.vipCustomerDescription")
                : this.value
                ? this.$t("message.switchOn")
                : this.$t("message.switchOff");
        },
        getOwnerTippyValue() {
            return this.field === "owner"
                ? this.$t("message.ownerDescription")
                : _.get(this.users, this.value, this.value);
        },
        getTippyValue() {
            if (this.field === "tags") {
                return this.mappedTags
                    .map(
                        (tag) =>
                            `<div style="background-color: ${tag.color}; padding: 2px 5px; border-radius: 3px;">${tag.name}</div>`
                    )
                    .join("");
            }
            const sanitizedHtml = SanitizeHtml(this.getValue()) || "N/A";
            return `<div style="text-align: start; font-weight: bold">${this.label}</div>${sanitizedHtml}`;
        },
        getValue() {
            return this.maskContactInfo(this.field, SanitizeHtml(this.value) || "N/A", 5);
        },
        copyValue() {
            copyText2Clipboard(this.getValue());
            this.$message.success(this.$t("message.copySuccess"));
        },
        handleEdit() {
            const isShouldMask = this.isShouldMask(this.value) || this.isMaskContactInfo(this.field);
            if (this.isSpecialField) {
                this.editedValue = !isShouldMask ? this.value : "";
                this.editModal = true;
            } else {
                this.showEditModal();
            }
        },
        showEditModal() {
            this.editedValue = !this.isShouldMask(this.value) || !isMaskContactInfo(this.field) ? this.value : "";
            this.editModal = true;
        },
        showAddModal() {
            this.newValue = "";
            this.addModal = true;
        },
        showDeleteModal() {
            this.deleteModal = true;
        },
        saveEdit() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (this.field === "email" && !emailRegex.test(this.editedValue)) {
                this.$message.error(this.$t('chat.contactDetailItem.invalidEmail'));
                return;
            }
            this.$emit("edit", this.editedValue);
            this.editModal = false;
        },
        saveAdd() {
            const validator = {
                text: (val) => val,
                email: (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
                phone: (val) => /^[\d\s\+\-]{5,15}$/.test(val),
                number: (val) => !isNaN(val),
                url: (val) => /^(http|https):\/\/[^ "]+$/.test(val),
                date: (val) => !isNaN(new Date(val).getTime()),
                dropdown: (val) => this.options.includes(val),
                json: (val) => {
                    try {
                        JSON.parse(val);
                        return true;
                    } catch (e) {
                        return false;
                    }
                },
            };
            if (!validator[this.inputType](this.newValue)) {
                this.$message.error(this.$t('chat.contactDetailItem.invalidValue'));
                return;
            }
            this.$emit("add", this.newValue);
            this.addModal = false;
        },
        confirmDelete() {
            this.$emit("delete");
            this.deleteModal = false;
        },
        savePreferredLang(newLang) {
            this.$emit("edit", newLang);
            this.editModal = false;
        },
        saveTagsUpdate(newTags) {
            this.$emit("edit", newTags);
            this.editModal = false;
        },
        getContactTagIds() {
            return this.contact.tags || [];
        },
        getTagStyle(color) {
            const isDark = this.isDarkColor(color);
            return {
                backgroundColor: this.lightenColor(color, 0.3),
                color: isDark ? "white" : "black",
                borderRadius: "12px",
                padding: "2px 8px",
                marginRight: "5px",
                display: "inline-flex",
                alignItems: "center",
                maxWidth: "100%",
                flexShrink: 0,
            };
        },
        isDarkColor(color) {
            const c = color.substring(1); // strip #
            const rgb = parseInt(c, 16); // convert rrggbb to decimal
            const r = (rgb >> 16) & 0xff; // extract red
            const g = (rgb >> 8) & 0xff; // extract green
            const b = (rgb >> 0) & 0xff; // extract blue
            const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
            return luma < 128;
        },
        lightenColor(color, percent) {
            const num = parseInt(color.slice(1), 16),
                amt = Math.round(2.55 * percent),
                R = (num >> 16) + amt,
                G = ((num >> 8) & 0x00ff) + amt,
                B = (num & 0x0000ff) + amt;
            return `#${(
                0x1000000 +
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            )
                .toString(16)
                .slice(1)}`;
        },
        removeTag(tagId) {
            const newTags = this.value.filter((id) => id !== tagId);
            this.$emit("edit", newTags);
        },
        appendEmailDomain(domain) {
            this.editedValue += domain;
        },
        getOwnerName(userId) {
            const owner = this.users[userId];
            return owner ? owner.name : this.$t("message.unowned");
        },
        initResizeObserver() {
            this.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    this.componentWidth = entry.contentRect.width;
                    this.isCompactView = this.componentWidth < 220;
                }
            });

            if (this.$refs.componentRef) {
                this.resizeObserver.observe(this.$refs.componentRef);
            }
        },
    },
    watch: {
        value(val) {
            this.editedValue = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.contact-detail-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0;
    position: relative;

    &:hover {
        .contact-detail-item-actions {
            opacity: 1;
            visibility: visible;
        }
    }

    &-details {
        width: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        flex: 1;
        padding-right: 80px;
    }

    &-icon {
        margin-right: 10px;
        color: #666;
    }

    &-input {
        width: 100%;
        overflow: hidden;
        flex: 1;

        &.owner {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &.vip-customer {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 18px;
            .vip {
                background: -webkit-linear-gradient(#d6ea2d, #f960cb, #9037d4);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        &.owner-field {
            .ant-select {
                width: 100%;
            }
        }

        &-label {
            font-size: 13px;
            font-weight: 600;
            color: #333;
            margin-bottom: 4px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            display: flex;
            align-items: center;
            gap: 2px;
        }

        &-val {
            font-size: 14px;
            color: #555;
            line-height: 1.4;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            &.add-link {
                color: #007bff;
                cursor: pointer;
                font-weight: 500;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    &-actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        gap: 4px;
        align-items: center;
        background-color: #fff;
        padding: 4px 8px;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease, visibility 0.2s ease;
        z-index: 10;

        &:hover {
            opacity: 1;
            visibility: visible;
        }

        .action-buttons {
            display: flex;
            gap: 4px;
        }

        .action-button {
            cursor: pointer;
            border: none;
            background: none;
            padding: 4px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;

            .material-icons {
                font-size: 16px;
                transition: color 0.3s ease;
            }

            &.edit-btn {
                .material-icons {
                    color: #4caf50;
                }

                &:hover {
                    background-color: rgba(76, 175, 80, 0.1);
                }
            }

            &.delete-button {
                .material-icons {
                    color: #f44336;
                }

                &:hover {
                    background-color: rgba(244, 67, 54, 0.1);
                }
            }

            &.copy-btn {
                .material-icons {
                    color: #2196f3;
                }

                &:hover {
                    background-color: rgba(33, 150, 243, 0.1);
                }
            }
        }
    }

    .url-link {
        color: #1890ff;
        text-decoration: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;

        &:hover {
            text-decoration: underline;
        }
    }

    .tags-container {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
    }

    .tag-label {
        display: inline-flex;
        align-items: center;
        border-radius: 12px;
        padding: 2px 8px;
        margin-right: 5px;
        font-size: 12px;
        max-width: 100%;
        flex-shrink: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .remove-tag {
            margin-right: 5px;
            cursor: pointer;
            font-weight: bold;
        }
    }
}

.owner-info {
    display: flex;
    align-items: center;
    gap: 8px;

    .owner-name {
        font-size: 14px;
        color: #333;
    }
}

.owner-field {
    &:hover {
        cursor: pointer;
        background: #f7f7f7;
    }
    .contact-detail-item-input-val {
        display: flex;
        align-items: center;
        min-height: 32px;

        .owner-content {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .set-unowned {
                width: 25px;
                height: 25px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .edit-icon {
            cursor: pointer;
            color: #1890ff;
            padding: 4px;

            &:hover {
                color: #40a9ff;
            }
        }
    }
}

.more-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 120px;

    .action-button {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        border: none;
        background: none;
        cursor: pointer;
        width: 100%;
        text-align: left;
        transition: background-color 0.3s;

        &:hover {
            background-color: #f5f5f5;
        }

        .material-icons {
            font-size: 18px;
        }

        .action-text {
            font-size: 14px;
            color: #333;
        }

        &.edit-btn {
            .material-icons {
                color: #4caf50;
            }
        }

        &.delete-button {
            .material-icons {
                color: #f44336;
            }
        }

        &.copy-btn {
            .material-icons {
                color: #2196f3;
            }
        }
    }
}

.conversation-actions-button {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    &:hover {
        background-color: #f5f5f5;
    }

    .material-icons {
        font-size: 20px;
        color: #666;
    }
}
</style>

<style lang="scss">
#vip-customer-modal-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: 100%;

    .modal-actions {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 15px;
    }
}
#contact-property-modal-content {
    .modal-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 15px;
    }

    input {
        width: 100%;
        padding: 8px;
        margin-bottom: 15px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    p {
        margin-bottom: 15px;
    }

    .email-suggestions {
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-top: 10px;

        span {
            cursor: pointer;
            color: #007bff;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}
.classic-button {
    border: none;
    background-color: #ffa80040;
    color: #ffa800;
    font-family: Poppins;
    font-weight: 600 !important;
    font-size: 14px;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.visitor-attr {
        font-size: 12px !important;
        padding: 1px 10px !important;
        font-weight: 400 !important;
    }

    &.open-note {
        padding: 3px !important;
        margin-right: 5px;

        span.material-icons {
            font-size: 16px !important;
        }
    }
}

.my-editor {
    background: #f7f7f7;
    color: #ccc;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
    max-height: 300px;
    overflow: scroll;
}

.json-editor {
    background: #f7f7f7;
    color: #ccc;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    padding: 5px;
    max-height: 400px;
    overflow: scroll;
}
</style>
